import { AccountHistoryTab } from '@/components/commercial/accounts/details/account-history-tab';
import type { CreditAnalysisTabProps } from './general-tab';

export function CreditAnalysisTimelineTab({ creditAnalysis }: CreditAnalysisTabProps) {
  if (!creditAnalysis.accountId) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>Conta não associada a esta análise de crédito</p>
      </div>
    );
  }

  return <AccountHistoryTab accountId={creditAnalysis.accountId} />;
}
